import CommentsPopup from './CommentsPopup';

export default CommentsPopup;
